<template>

</template>

<script>
export default {
    props:{
        errors:String
    },
    name: "Noty",
    mounted() {
        this.$notify({
            title: this.trans('Notification'),
            text: this.errors,
            type: 'error',
        });
    }
}
</script>

<style scoped>

</style>
